import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const overquotaAfterClearTariffId = 'W128G1m_single_quota_2022_cloud';

// CLOUDWEB-18440
// Вернуть шаг оплаты перед запросом на восстановление (под фичтоглом)
export const overquotaPayRestore: boolean = getFeature('overquota-pay-restore') || false;
